import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { AlertTriangle } from "lucide-react";

interface RiskData {
    name: string;
    email: string;
    days_since: number;
}

interface ChurnRiskListProps {
    risks: RiskData[];
}

const ChurnRiskList: React.FC<ChurnRiskListProps> = ({ risks }) => {
    return (
        <Card className="col-span-1">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium text-destructive">At Risk Customers</CardTitle>
                <AlertTriangle className="h-4 w-4 text-destructive" />
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    {risks && risks.length > 0 ? (
                        risks.slice(0, 5).map((risk, i) => (
                            <div key={i} className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm font-medium leading-none">{risk.name}</p>
                                    <p className="text-xs text-muted-foreground">{risk.email}</p>
                                    <p className="text-xs text-muted-foreground">{risk.days_since} days since last order</p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-sm text-muted-foreground py-4">No high-risk customers detected</div>
                    )}
                </div>
            </CardContent>
        </Card>
    );
};

export default ChurnRiskList;
